import type {
  ApiStaffHomeArrivalsResponse,
  ApiStaffHomeDayResponse,
} from '@mfw/common';

import { get } from './axios';

export interface FetchStaffHomeDayArgs {
  organizationId: string;
  date: string;
  search?: string;
  offset?: number;
  limit?: number;
  onlyCheckedIn?: boolean;
}

export const fetchStaffHomeDay = ({
  organizationId,
  date,
  search,
  offset,
  limit,
  onlyCheckedIn,
}: FetchStaffHomeDayArgs) => {
  return get<ApiStaffHomeDayResponse>(
    `/v2/organizations/${organizationId}/staff-home/day`,
    {
      query: {
        date,
        search,
        offset: offset?.toString(),
        limit: limit?.toString(),
        ...(onlyCheckedIn ? { onlyCheckedIn: 'true' } : {}),
      },
    },
  );
};

export interface FetchStaffHomeArrivalsArgs {
  organizationId: string;
  date: string;
  search?: string;
  offset?: number;
  limit?: number;
}

export const fetchStaffHomeArrivals = async ({
  organizationId,
  date,
  search,
  offset,
  limit,
}: FetchStaffHomeArrivalsArgs) => {
  const body = await get<ApiStaffHomeArrivalsResponse>(
    `/v2/organizations/${organizationId}/staff-home/arrivals`,
    {
      query: {
        date,
        search,
        offset: offset?.toString(),
        limit: limit?.toString(),
      },
    },
  );
  // The current-key column shows the row keys as the server evaluated them
  // at `asOf`; the receipt stamp marks a usable snapshot
  // (see `useLockerKeySnapshot`).
  return body && { ...body, receivedAt: performance.now() };
};
